<div class="container">
  <div class="header">
    <div class="icon-title">
      <mat-icon class="icon">{{ data.icon }}</mat-icon>
      <span class="title">{{ data.title }}</span>
    </div>

    <span class="subtitle">{{ data.message }}</span>
  </div>
</div>
